import { Check, Info, UtensilsCrossed } from "lucide-react";
import Reveal from "@/components/Reveal";

/**
 * Seção "Regime & Inclusões" — alimentada exclusivamente pelos dados
 * verificados de cada resort (campo `board` em src/data/resorts.js).
 * Todo resort novo com `board` cadastrado ganha a seção automaticamente.
 */
export default function BoardPlan({ resort }) {
    const board = resort?.board;
    if (!board) return null;

    return (
        <section className="bg-white py-20 sm:py-28" data-testid="board-section">
            <div className="mx-auto max-w-6xl px-4 sm:px-6">
                <Reveal className="text-center">
                    <p className="text-xs font-semibold uppercase tracking-[0.22em] text-gold-hover">Regime & Inclusões</p>
                    <h2 className="mx-auto mt-3 max-w-2xl font-serif text-3xl font-semibold tracking-tight text-forest-deep sm:text-4xl">
                        O que está incluído na diária
                    </h2>
                    <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-stone-600">{board.intro}</p>
                </Reveal>

                <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_1.4fr]">
                    <Reveal>
                        <div className="flex h-full flex-col justify-between rounded-3xl bg-forest-deep p-8 text-white" data-testid="board-regime">
                            <div>
                                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gold/15 text-gold">
                                    <UtensilsCrossed className="h-6 w-6" />
                                </span>
                                <p className="mt-6 text-[11px] font-semibold uppercase tracking-[0.2em] text-stone-400">Regime de alimentação</p>
                                <p className="mt-2 font-serif text-3xl font-semibold text-gold">{board.regime}</p>
                            </div>
                            <p className="mt-8 border-t border-white/10 pt-5 text-xs leading-relaxed text-stone-400">
                                Informações verificadas no site oficial do empreendimento. Confirmamos todos os detalhes do período na sua cotação personalizada.
                            </p>
                        </div>
                    </Reveal>

                    <Reveal delay={0.12}>
                        <div className="h-full rounded-3xl border border-[#E5DEC9] bg-sand p-8">
                            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-stone-500">Incluído na diária</p>
                            <ul className="mt-5 space-y-3.5" data-testid="board-included">
                                {board.included.map((item) => (
                                    <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-forest-deep">
                                        <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forest-emerald/10 text-forest-emerald">
                                            <Check className="h-3 w-3" strokeWidth={3} />
                                        </span>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                            {board.extras?.length > 0 && (
                                <div className="mt-7 border-t border-[#E5DEC9] pt-5" data-testid="board-extras">
                                    <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-stone-500">Serviços adicionais & observações</p>
                                    <ul className="mt-3.5 space-y-2.5">
                                        {board.extras.map((item) => (
                                            <li key={item} className="flex items-start gap-3 text-xs leading-relaxed text-stone-500">
                                                <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold-hover" />
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
